import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { FormControl, InputGroup } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "../modal/modal.css";
import TableComponent from "../../../../components/tableComponent/TableComponent";

import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  Accordion,
  CircularProgress,
  TableHead,
  TextField,
} from "@mui/material";
import { SelectAll } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationModal from "../../../../components/common/ConfirmationModal";
import { useDispatch } from "react-redux";
import {
  fetchAwrListRequest,
  fetchCategoryRequest,
  fetchGradeRequest,
  fetchInvoiceDetailsIdRequest,
  fetchMarkRequest,
  fetchMarkTypeRequest,
  fetchSaleNumbersRequest,
  fetchSampleShortageListRequest,
  fetchSampleShortageRequest,
  fetchSessionTypeRequest,
  fetchWarehouseUserRequest,
  teaTypeAction,
} from "../../../../store/actions";
import CustomeFormCreater from "../../../../components/common/formCreater/CustomeFormCreater";

import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import axios from "axios";
import ConvertTo12HourFormat from "../../../../components/common/dateAndTime/ConvertTo12HourFormat";

import axiosMain from "../../../../http/axios/axios_main";
import PrePostDate from "./PrePostDate";
import CustomToast from "../../../../components/Toast";
import { useAuctionDetail } from "../../../../components/common/AunctioneerDeteailProvider";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import newformatDateToDdMmYy from "../../../../components/common/dateAndTime/newconvertToDate";
import { useLoader } from "../../../../components/common/Loder/Loder";
import { ExportToPDF } from "../../../../components/common/DownloadTable";
import ExportData from "../../../../components/common/exportData/ExportData";
import { LocalizationProvider, TimePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "react-datepicker";
import "./time-picker.css";
import "react-datepicker/dist/react-datepicker.css";

// import Loder from "../../../../components/common/Loder/Loder";

const allSampleShortage = [];

const currentDate = new Date().toISOString()?.split("T")[0];

// Get the current year
const currentYear = new Date().getFullYear()?.toString();

const currentWeek = Math.ceil(
  ((new Date() - new Date(currentYear, 0, 4)) / 86400000 + 1) / 7
);

console.log(currentWeek, currentDate, "currentWeek");

const validationSchema = Yup.object().shape({
  // season: Yup.string().required("Season is required"),
  saleNo: Yup.string().required("Sale No is required"),
  noOfSession: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter No. of Session")
    .integer("Please enter a number Without Decimal"),
});

function Maintananse({ modalRight, ...dataBy }) {
  const [value, setValue] = React.useState(null);
  const [rows, setRows] = useState(allSampleShortage);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectAllRow, setSelectAllRow] = useState(false);
  const [actionData, setActionData] = useState({
    view: {},
    edit: {},
  });
  const [openConformationModal, setOpenConformationModal] = useState(false);
  const [bools, setbool] = useState(false);
  const [updatemessage, setupdatemessage] = useState("");

  const [rowValues, setRowValues] = useState([]);
  const [auctionType, setAuctionType] = useState(dataBy?.auctionType);
  const [baseUrlEng, setBaseUrlEng] = useState(
    dataBy?.auctionType === "ENGLISH"
      ? "EnglishAuctionSession"
      : "AuctionSession"
  );

  const dispatch = useDispatch();
  const {
    auctionDetailId,
    auctionCenterUserId,
    auctionCenterId,
    userId,
    roleCode,
  } = useAuctionDetail();
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

  const [handleChnage, setHandleChnage] = useState(false);
  const [saleNo, setSaleNo] = useState([]);
  const [warehouseUserList, setWarehouseUserList] = useState([]);
  const [gradesList, setGradesList] = useState([]);
  const [showLoder, setShowLoder] = useState(false);
  const [numRows, setNumRows] = useState(1);
  const [markDataList, setMarkDataList] = useState([]);
  const [catagory, setCategory] = useState([]);
  const [teaTypeList, setTeaTeatypeList] = useState([]);
  const [teaTypeListdtls, setTeaTeatypeListdtls] = useState([]);
  const [startDate, setStartDate] = useState("");

  const [selectedSalePrograms, setSelectedSalePrograms] = useState([]);
  const [sessionTypes, setSessionType] = useState([]);
  const [saleProgramIds, setSaleProgramId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(0);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, numRows);
  let data = dataBy?.dataByID?.responseData?.at(0)?.searchParam;
  const [Exceldatafordownload, setExceldatafordownload] = useState([]);
  const [ExceldatafordownloadfirstRow, setExceldatafordownloadfirstRow] =
    useState([]);
  const itemsOnPage = Array?.from(
    {
      length: data === undefined ? numRows : 1,
    },
    (_, index) => index + startIndex
  );

  const { dataByID, onEdit, expandedTab } = dataBy;

  // const [formData, setFormData] = useState(
  //   dataBy?.dataByID?.responseData?.at(0)?.searchParam
  // );
  const columnsdata = [
    { name: "auctioner", title: "Auctioner" },
    { name: "teaTypeName", title: "Tea Type" },
    { name: "category", title: "Category" },
    { name: "SessionType", title: "Session Type" },
    { name: "saleDate", title: "Sale Date" },
    { name: "startDate", title: "Start Date" },
    { name: "enddate", title: "End Date" },
    { name: "minimumBidTime", title: "Minimum Bid" },
    { name: "noOfLots", title: "Lots" },
    { name: "status", title: "Status" },
  ];

  const columnsdataNew = [
    { name: "season", title: "Season" },
    { name: "saleNo", title: "Sale No" },
    { name: "saleDate", title: "Sale Date" },
    { name: "teaType", title: "Tea Type" },
    { name: "noOfSession", title: "No Of Session" },
    // { name: "dealBookClosingDate", title: "Deal Book Closing Date" },
    { name: "pop", title: "it will pop" },
  ];
  const [auctioneer, setAuctioneer] = useState([]);
  const [dataListBy, setDataBy] = useState(dataBy);
  const [smShow, setSmShow] = useState(false);
  const [show, setShow] = useState(false);
  const [prePostData, setPrePostData] = useState([]);
  const [saleDates, setSaleDates] = useState([]);
  const [markType, setMarkType] = useState([]);
  const [auctionSessionDetailId, setAuctionSessionDetailId] = useState({});
  const [
    timeIntervalBetweenTwoAuctionSessionData,
    setTimeIntervalBetweenTwoAuctionSessionData,
  ] = useState({});
  const [columns, setColumns] = useState(
    [
      { label: "Auctioneer", id: "userId", minWidth: "200px" },
      auctionType !== "ENGLISH"
        ? { label: "Market Type", id: "marketTypeId", minWidth: "200px" }
        : null, // Return null instead of false
      { label: "Tea Type", id: "teaTypeId", minWidth: "200px" },
      { label: "Category", id: "categoryId", minWidth: "200px" },
      { label: "Session Type", id: "sessionTypeId", minWidth: "200px" },
      { label: "Sale Date", id: "saleDate" },
      { label: "Start Time", id: "startDate" },
      { label: "End Time", id: "enddate" },
      { label: "Minimum Bid Time", id: "minimumBidTime" },
      { label: "No Of Lots", id: "noOfLots" },
      {
        label: "Deal Book Closing Date & Time",
        id: "dealBookClosingDateTimeRow",
      },
      { label: "Status", id: "status", minWidth: "100px" },
    ].filter(Boolean) // This removes null or false values
  );
  const [oldDealBookClosingDate, setoldDealBookClosingDate] = useState(null);
  const initialValues = {
    season: currentYear?.toString(),
    saleNo: null,
    saleDate: "",
    teaTypeId: null,
    createdBy: parseInt(userId),
    noOfSession: 1,
    // dealBookClosingDate: "",
    sessionList: selectedSalePrograms,
  };

  const teaType = useSelector(
    (state) => state.teaType.teaTypeList.responseData
  );

  function checkKeys(keys) {
    selectedSalePrograms.forEach((obj, index) => {
      keys.forEach((key) => {
        if (!(key in obj)) {
          console.log(`Missing key '${key}'`, "Missing key");
        } else if (obj[key] === undefined || obj[key] === null) {
          console.log(`Missing value for key '${key}'`);
        } else {
          return true;
        }
      });
    });
  }

  const formik = useFormik({
    initialValues: {
      season: currentYear,
      saleNo: null,
      saleDate: "",
      teaTypeId: null,
      createdBy: parseInt(userId),
      noOfSession: 1,
      // dealBookClosingDate: "",
      sessionList: selectedSalePrograms,
    },
    validationSchema,
    onSubmit: (values) => {
      // selectedSalePrograms?.map((ele) => (ele.teaTypeId = values.teaTypeId));
      const {
        season,
        saleNo,
        saleDate,
        teaTypeId,
        createdBy,
        categoryId,
        noOfSession,
        // dealBookClosingDate,
        sessionList,
      } = values;
      if (sessionList?.length > 0) {
        const requiredKeys = [
          "userId",
          "marketTypeId",
          // "remarks",
          "teaTypeId",
          "categoryId",
          "startDate",
          "enddate",
          "noOfLots",
        ];
        checkKeys(requiredKeys);

        //sdp
        let enterdealBookClosingDateRow = selectedSalePrograms
          ?.map((ele, index) =>
            ele.dealBookClosingDateTimeRow === null ||
            ele.dealBookClosingDateTimeRow === undefined
              ? index + 1
              : ""
          )
          .filter(
            (ele, index) =>
              ele !== "" &&
              index + 1 <= (noOfSession !== "" ? parseInt(noOfSession) : 0)
          );
        if (enterdealBookClosingDateRow.length > 0) {
          CustomToast.error("Please select Deal Book Closing Date");
          return false;
        }

        let enterSdate = selectedSalePrograms
          ?.map((ele, index) =>
            ele.startDate === null || ele.startDate === undefined
              ? index + 1
              : ""
          )
          .filter(
            (ele, index) =>
              ele !== "" &&
              index + 1 <= (noOfSession !== "" ? parseInt(noOfSession) : 0)
          );
        if (enterSdate.length > 0) {
          CustomToast.error("Please select Start Time");
          return false;
        }
        let enterEdate = selectedSalePrograms
          ?.map((ele, index) =>
            ele.enddate === null || ele.enddate === undefined ? index + 1 : ""
          )
          .filter(
            (ele, index) =>
              ele !== "" &&
              index + 1 <= (noOfSession !== "" ? parseInt(noOfSession) : 0)
          );
        if (enterEdate.length > 0) {
          CustomToast.error("Please select End Time");
          return false;
        }
        //-End

        let endDate = selectedSalePrograms
          ?.map((ele, index) =>
            ele.enddate === null || ele.enddate === undefined ? index + 1 : ""
          )
          .filter(
            (ele, index) =>
              ele !== "" &&
              index + 1 <= (noOfSession !== "" ? parseInt(noOfSession) : 0)
          );

        if (
          endDate.length > 0 ||
          selectedSalePrograms
            ?.map((ele, index) =>
              new Date(ele.startDate) > new Date(ele.enddate) ? index : ""
            )
            .filter((ele) => ele !== "").length > 0
        ) {
          CustomToast.error(
            endDate?.length > 0
              ? "Row No of " +
                  endDate?.join(" , ") +
                  " End Date is less then Start Date"
              : "Row No of " +
                  selectedSalePrograms
                    ?.map((ele, index) =>
                      new Date(ele.startDate) > new Date(ele.enddate)
                        ? index + 1
                        : ""
                    )
                    .filter((ele) => ele !== "")
                    ?.join(" , ") +
                  "End Date is less then Start Date"
          );
        } else {
          const apiUrl = `/preauction/${baseUrlEng}/CreateAuctionSession`;

          const extractedData = selectedSalePrograms.map((program) => ({
            season:
              season === "" ? new Date().getFullYear()?.toString() : season,
            saleNo: parseInt(saleNo),
            auctionCenterId: auctionCenterId,

            auctionSessionId: program.auctionSessionId,
            auctionSessionDetailId: program.auctionSessionDetailId,
            userId: program.userId !== "" ? parseInt(program.userId) : 0,
            marketTypeId: program.marketTypeId,
            // marketTypeId: markType?.at(0).marketTypeId,
            categoryId: program.categoryId,
            saleDate: saleDate,
            // teaTypeId: program.teaTypeId,
            // teaTypeId: values.teaTypeId,
            teaTypeId:
              dataBy?.dataByID?.responseData?.at(0) !== undefined
                ? program.teaTypeId
                : program.teaTypeId === undefined
                ? teaTypeListdtls?.at(0)?.TeaTypeId
                : teaTypeListdtls
                    .map((ele) => ele.TeaTypeId)
                    ?.includes(program.teaTypeId)
                ? program.teaTypeId
                : teaTypeListdtls?.at(0)?.TeaTypeId,
            sessionTypeId:
              program.sessionTypeId === undefined
                ? sessionTypes?.at(0)?.sessionTypeId
                : sessionTypes
                    .map((ele) => ele.sessionTypeId)
                    ?.includes(program.sessionTypeId)
                ? program.sessionTypeId
                : sessionTypes?.at(0)?.sessionTypeId,
            sessionTypeName:
              program.sessionTypeId == undefined
                ? auctionType === "ENGLISH"
                  ? sessionTypes?.at(0)?.sessionTypeId === 3
                    ? "Normal"
                    : "Supplement"
                  : sessionTypes?.at(0)?.sessionTypeId === 1
                  ? "Normal"
                  : "Price Rediscovery Session"
                : sessionTypes
                    ?.filter(
                      (ele) => ele?.sessionTypeId === program.sessionTypeId
                    )
                    ?.at(0)?.sessionTypeName,
            //  program.sessionTypeId === 1
            // ? "Normal"
            // : "Price Rediscovery Session"
            startDate: program.startDate,
            enddate: program.enddate,
            minimumBidTime: program.minimumBidTime,
            noOfLots: program.noOfLots,
            updatedBy: parseInt(userId),
            status: program.status,
            // remarks: program.remarks,
            // dealBookClosingDate: dealBookClosingDate,
            dealBookClosingDate: program?.dealBookClosingDateTimeRow,
          }));
          // //debugger;
          if (
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.userId === undefined ? false : ele.userId > 0
              )
              .includes(false)
          ) {
            CustomToast.error("Please Select Auctioner");
            setShowLoder(false);
            closeLoader();
            return false;
          } else if (
            auctionType !== "ENGLISH" &&
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.marketTypeId === undefined ? false : ele.marketTypeId > 0
              )
              .includes(false)
          ) {
            CustomToast.error("Please Select Market Type");
            setShowLoder(false);
            closeLoader();
            return false;
          } else if (
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.teaTypeId === undefined ? false : ele.teaTypeId > 0
              )
              .includes(false)
          ) {
            CustomToast.error("Please Select Tea Type ");
            setShowLoder(false);
            closeLoader();
            return false;
          } else if (
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.categoryId === undefined ? false : ele.categoryId > 0
              )
              .includes(false)
          ) {
            CustomToast.error("Please Select Category");
            setShowLoder(false);
            closeLoader();
            return false;
          } else if (
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.noOfLots === undefined || ele.noOfLots === "" ? false : true
              )
              .includes(false)
          ) {
            CustomToast.error("Please enter No. of Lots");
            setShowLoder(false);
            closeLoader();
            return false;
          } else if (
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.noOfLots !== undefined && ele.noOfLots !== ""
                  ? ele.noOfLots > 0
                  : true
              )
              .includes(false)
          ) {
            // debugger;
            CustomToast.error("ZERO value will not be allowed");
            setShowLoder(false);
            closeLoader();
            return false;
          } else if (
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.minimumBidTime !== undefined && ele.minimumBidTime !== ""
                  ? ele.minimumBidTime > 0
                  : true
              )
              .includes(false)
          ) {
            // debugger;
            CustomToast.error("ZERO value will not be allowed");
            setShowLoder(false);
            closeLoader();
            return false;
          } else if (
            extractedData?.at(0).sessionTypeId !== 2 &&
            selectedSalePrograms
              .slice(0, parseInt(noOfSession))
              ?.map((ele) =>
                ele.minimumBidTime === undefined || ele.minimumBidTime === ""
                  ? false
                  : true
              )
              .includes(false)
          ) {
            // debugger;
            CustomToast.error("Please enter MBT");
            setShowLoder(false);
            closeLoader();
            return false;
          } else {
            if (dataBy?.dataByID?.responseData?.at(0) !== undefined) {
              if (auctionType === "ENGLISH")
                delete extractedData?.at(0)?.marketTypeId;
              // delete extractedData?.at(0)?.remarks;
              openLoader();
              axiosMain
                .post(
                  `/preauction/${baseUrlEng}/UpdateAuctionSession?flag=` +
                    bools,
                  {
                    ...extractedData?.at(0),
                    loggedInUserRole: atob(localStorage.getItem("argument6")),
                    loggedInUserCode: atob(sessionStorage.getItem("argument4")),
                    oldDealBookClosingDate: oldDealBookClosingDate,
                    auctioneerCode:
                      extractedData?.at(0).sessionTypeId !== 2
                        ? auctioneer
                            ?.filter(
                              (ele) =>
                                ele.userId === extractedData?.at(0)?.userId
                            )
                            ?.at(0).userCode
                        : "",
                  }
                )
                .then((response) => {
                  console.log(response, "Sss");
                  if (response.data.statusCode === 200) {
                    CustomToast.success(response.data.message);
                    formik.resetForm();
                    setbool(false);
                    setupdatemessage("");
                    setSelectedSalePrograms([]);
                    setShowLoder(false);
                    dataBy?.setExpandedTab("panel1");
                    dataBy.resetTableData();
                    dataBy?.setDataByID([]);
                    // dataBy?.setDisable(false);
                    // dataBy?.setEdit(false);
                    // dataBy?.setActionClick(false);
                  } else if (response.data.statusCode === 422) {
                    setOpenConformationModal(true);
                    setupdatemessage(response.data.message);
                    setShowLoder(false);
                  } else {
                    CustomToast.warning(response.data.message);
                    setShowLoder(false);
                  }
                  // Handle the API response here
                  closeLoader();
                })
                .catch((error) => {
                  // Handle errors here
                  setShowLoder(false);
                  closeLoader();
                });
            } else {
              openLoader();
              axiosMain
                .post(apiUrl, {
                  season:
                    season === ""
                      ? new Date().getFullYear()?.toString()
                      : season,
                  saleNo: parseInt(saleNo),
                  saleDate: saleDate,
                  saleProgramId: saleProgramIds?.at(0).SaleProgramId,
                  teaTypeId: teaTypeId,
                  categoryId: categoryId,
                  createdBy: parseInt(userId),
                  noOfSession: noOfSession !== "" ? parseInt(noOfSession) : 0,

                  sessionList: extractedData.filter(
                    (ele, index) =>
                      index + 1 <=
                      (noOfSession !== "" ? parseInt(noOfSession) : 0)
                  ),

                  // dealBookClosingDate: dealBookClosingDate,
                  auctionCenterId: auctionCenterId,
                })
                .then((response) => {
                  setShowLoder(false);

                  console.log(response, "Sss");
                  if (response.data.statusCode === 200) {
                    CustomToast.success(response.data.message);
                    formik.resetForm();
                    setSelectedSalePrograms([]);
                    // dataBy.resetTableData();

                    dataBy?.setExpandedTab("panel1");
                  } else {
                    CustomToast.warning(response.data.message);
                  }
                  closeLoader();

                  // Handle the API response here
                  // setRows(response?.data?.responseData[0]);
                })
                .catch((error) => {
                  // Handle errors here
                  setShowLoder(false);
                  closeLoader();
                });
            }
          }
        }

        // console.log(results, "results");
      } else {
        CustomToast.error("Please fill auction session.");
        setShowLoder(false);
        closeLoader();
      }

      // console.log(data, selectedSalePrograms, "results");
    },
    validateOnBlur: false, // Disable validation on blur
    validateOnChange: handleChnage, // Disable validation on change
    isInitialValid: false,
  });

  function ResetAddDropDown() {
    setAuctioneer([]);
    setMarkType([]);
    setCategory([]);
  }

  function addStartDateInNextRow(index, value, updatedProgram) {
    const selectedTime = value;
    const [hours, minutes] = selectedTime.split(":").map(Number);
    const newMinutes =
      (minutes +
        timeIntervalBetweenTwoAuctionSessionData?.timeIntervalBetweenTwoAuctionSession) %
      60; // Adding 10 minutes
    const newHours =
      hours +
      Math.floor(
        (minutes +
          timeIntervalBetweenTwoAuctionSessionData?.timeIntervalBetweenTwoAuctionSession) /
          60
      ); // Updating hours if necessary
    const updatedTime = `${String(newHours).padStart(2, "0")}:${String(
      newMinutes
    ).padStart(2, "0")}`;

    const updatedPrograms = {
      ...selectedSalePrograms[index + 1],
      startDate: formik?.values?.saleDate + "T" + updatedTime + ":00",
    };

    console.log(updatedPrograms, "updatedProgramupdatedProgramupdatedProgram");
    try {
      selectedSalePrograms[index + 1] = updatedPrograms;

      // You can perform the API call regardless of whether saleDate is available or not

      console.log(
        selectedSalePrograms,
        selectedSalePrograms,
        "updatedProgramssupdatedProgramssupdatedProgramss"
      );
    } catch (error) {
      console.error("API call error:", error);
      // Handle the error if needed
    }
    updateSelectedSaleProgram(index, updatedProgram);
  }

  useEffect(() => {
    if (dataBy?.dataByID?.responseData?.at(0) !== undefined) {
      const viewdata = dataBy?.dataByID?.responseData?.at(0);
      let exceldatanew = [];
      const newData = {
        season: viewdata?.season,
        saleNo: viewdata?.saleNo,
        saleDate: viewdata?.saleDate.split("T")?.[0],
        teaType: viewdata?.teaTypeName,
        noOfSession: viewdata?.noOfSession,
        // status: saleProgramDetailList[0]?.status,
        dealBookClosingDate: viewdata?.dealBookClosingDate,
      };
      exceldatanew.push(newData);

      setExceldatafordownload(exceldatanew);

      let newDetails = [];
      const obsecondrow = {
        auctioner: viewdata?.userName,
        teaTypeName: viewdata?.teaTypeName,
        category: viewdata?.categoryName,
        SessionType: viewdata?.sessionTypeName,
        saleDate: viewdata?.saleDate.split("T")?.[0],
        startDate: viewdata?.startDate.split("T")?.[0],
        enddate: viewdata?.enddate.split("T")?.[0],
        minimumBidTime: viewdata?.minimumBidTime,
        noOfLots: viewdata?.noOfLots,
        status: getStatus(viewdata?.status),
      };
      newDetails.push(obsecondrow);
      setExceldatafordownloadfirstRow(newDetails);
    }
  }, [dataBy?.dataByID?.responseData?.at(0)]);
  const getStatus = (status) => {
    switch (status) {
      case 0:
        return "Pending";
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      case 3:
        return "Warm up";
      case 4:
        return "Closed";
      case 5:
        return "Cancelled";
      case 6:
        return "Hold";
      case 7:
        return "Resume";
      case 8:
        return "PrePond";
      case 9:
        return "PostPond";
      default:
        return "-";
    }
  };
  function getEditValues() {
    //let data = dataBy?.dataByID?.responseData?.at(0)?.searchParam;
    let data = dataBy?.dataByID?.responseData?.at(0);
    setSelectedSalePrograms([
      {
        ...dataBy?.dataByID?.responseData?.at(0),
        // dealBookClosingDateTimeShow: onEdit === false ? dataBy?.dataByID?.responseData?.at(0)?.dealBookClosingDate?.replace("T", " ")?.slice(0, 16) : convertToCustomFormat(dataBy?.dataByID?.responseData?.at(0)?.dealBookClosingDate?.replace("T", " ")?.slice(0, 16)),
        dealBookClosingDateTimeRow:
          dataBy?.dataByID?.responseData?.at(0)?.dealBookClosingDate,
        dealBookClosingDateTimeShow:
          dataBy?.dataByID?.responseData?.at(0)?.dealBookClosingDate,
      },
    ]);
    setoldDealBookClosingDate(
      dataBy?.dataByID?.responseData?.at(0)?.dealBookClosingDate
    );
    // debugger
    if (data !== undefined) {
      formik.setValues({
        ...formik.values,
        season: data.season,
        saleNo: data.saleNo,
        saleDate: dataBy?.dataByID?.responseData?.at(0)?.saleDate.split("T")[0],
        teaTypeId: data.teaTypeId,
        createdBy: parseInt(userId),
        noOfSession: data.noOfSession,
        sessionList: selectedSalePrograms,
        dealBookClosingDate: data.dealBookClosingDate,
      });

      axiosMain
        .post("/admin/Category/dropdown/getcategory", {
          teaTypeId: dataBy?.dataByID?.responseData?.at(0)?.teaTypeId,
          auctionCenterId: auctionCenterId,
          isCategory: 1,
        })
        .then((response) => {
          if (catagory?.length <= 0) {
            setCategory(
              response?.data?.responseData?.map((ele) => ({
                ...ele,
                teaTypeId: parseInt(
                  dataBy?.dataByID?.responseData?.at(0)?.teaTypeId
                ),
              }))
            );
            // debugger;
          } else {
            if (
              !catagory
                ?.map((ele) => ele.teaTypeId)
                ?.includes(
                  parseInt(dataBy?.dataByID?.responseData?.at(0)?.teaTypeId)
                )
            ) {
              setCategory([
                ...catagory,
                ...response?.data?.responseData?.map((ele) => ({
                  ...ele,
                  teaTypeId: parseInt(
                    dataBy?.dataByID?.responseData?.at(0)?.teaTypeId
                  ),
                })),
              ]);
              // debugger;
            }
          }
        });

      const marketTypeId = "/preauction/Common/BindMarketTypeByParam";

      axiosMain
        .post("/preauction/Common/BindAuctioneerByInvoice", {
          season: data.season,
          saleNo: parseInt(data.saleNo),
          AuctioneerId: data.userId, //auctioner
          auctionCenterId: auctionCenterId,
        })
        .then((response) => {
          // Handle the API response here'

          setAuctioneer(response?.data?.responseData);

          console.log(response);
        });
      axiosMain
        .post(marketTypeId, {
          season: data.season,
          saleNo: parseInt(data.saleNo),
          AuctioneerId: parseInt(data?.userId),
          auctionCenterId: auctionCenterId,
        })
        .then((res) => {
          setMarkType(
            res?.data?.responseData?.map((ele) => ({
              ...ele,
              auctioneerId: parseInt(data?.userId),
            }))
          );
          console.log(res?.data?.responseData, "response?.data?.responseData");
        })
        .catch((error) => {
          // Handle errors here
        });
    } else {
      console.log(data);
    }
  }

  useEffect(() => {
    getEditValues();
    // //debugger;
  }, [dataBy?.dataByID]);

  const resetForm = () => {
    formik.handleReset();
    setHandleChnage(false); // Reset the "handleChange" flag as well
    fields
      .filter(
        (field) => field.type === "select" || field.type === "disableSelect"
      )
      .forEach((field) => {
        formik.setFieldValue(field.name, "");
      });
    setTeaTeatypeListdtls([]);
    setTeaTeatypeList([]);
    setCategory([]);
    setSelectedSalePrograms([
      {
        userId: 0,
        marketTypeId: 0,
        // categoryId: 1,
        categoryId: 0,
        // teaTypeId: 1,
        teaTypeId: 0,
        sessionTypeId: 1,
        saleDate: formik.values.saleDate,
        startDate: null,
        enddate: null,
        minimumBidTime: 1,
        noOfLots: 0,
        status: 0,
        remarks: "",
        dealBookClosingDateTimeRow: "",
        dealBookClosingDateTimeShow: "",
      },
    ]);
    setNumRows(1);

    // console.log(, "updatedProgram");
  };

  useEffect(() => {
    // resetForm();
    if (expandedTab === "panel1") {
      resetForm();
      ResetAddDropDown();
      console.log(expandedTab, "expandedTab");
    }
  }, [expandedTab]);

  useEffect(() => {
    formik.setFieldValue("sessionList", selectedSalePrograms);
  }, [selectedSalePrograms]);

  const saleNumber = useSelector(
    (state) => state?.CreatedSaleNo?.saleNumbers?.responseData
  );
  const category = useSelector((state) => state?.category?.data?.responseData);
  const sessionType = useSelector(
    (state) => state?.sessionTypesReducer?.data?.responseData
  );
  // console.log(invoiceData, "invoiceData");
  useEffect(() => {
    setAuctioneer([]);
    formik.setFieldValue("season", currentYear);
    dispatch(fetchSaleNumbersRequest(currentYear.toString()));
    dispatch(teaTypeAction({ auctionCenterId }));
    dispatch(fetchMarkTypeRequest());
    dispatch(
      fetchCategoryRequest({
        teaTypeId: parseInt(formik.values.teaTypeId),
        auctionCenterId,
        isCategory: 1,
      })
    );
    dispatch(fetchSessionTypeRequest());
    axiosMain
      .post("/admin/user/dropdown/getUserDetail", { roleCode })
      .then((response) => {
        // Handle the API response here
        setAuctioneer(response.data.responseData);
      })
      .catch((error) => {
        // Handle errors here
      });

    axiosMain
      .get("/admin/ruleEngine/getByAuctionCenterId/" + auctionCenterId, {
        roleCode,
      })
      .then((response) => {
        // Handle the API response here
        // setAuctioneer(response.data.responseData);
        if (response.data.statusCode === 200) {
          setTimeIntervalBetweenTwoAuctionSessionData(
            response.data.responseData
          );
        } else {
          setTimeIntervalBetweenTwoAuctionSessionData(10);
          CustomToast.warning(response.data.message);
        }
        // setTimeIntervalBetweenTwoAuctionSessionData(response.data.responseData);
        console.log(response, "responseresponse");
      })
      .catch((error) => {
        // Handle errors here
      });
  }, []);

  useEffect(() => {
    formik.values.season = currentYear;

    setSaleNo(saleNumber);
  }, [saleNumber]);

  useEffect(() => {
    setSessionType(sessionType);
  }, [sessionType]);

  useEffect(() => {
    if (formik.values.season !== "") {
      dispatch(fetchSaleNumbersRequest(formik.values.season));
    }

    // setSelectedSalePrograms([])
    if (dataBy?.dataByID?.responseData?.at(0) === undefined) {
      setSaleDates([]);
      setNumRows(1);
      setTeaTeatypeListdtls([]);
      setTeaTeatypeList([]);
      setCategory([]);
      setSelectedSalePrograms([
        {
          userId: 0,
          marketTypeId: 0,
          // categoryId: 1,
          categoryId: 0,
          // teaTypeId: 1,
          teaTypeId: 0,
          sessionTypeId: 1,
          saleDate: formik.values.saleDate,
          startDate: null,
          enddate: null,
          minimumBidTime: 1,
          noOfLots: 0,
          status: 0,
          remarks: "",
          dealBookClosingDateTimeRow: "",
        },
      ]);
    }
    const saleNo = formik.values.saleNo;
    const season =
      formik.values.season === ""
        ? currentYear?.toString()
        : formik.values.season;
    // API endpoint URL
    const apiUrlAuctioneer = "/preauction/Common/BindAuctioneerByInvoice";

    // Data to be sent in the POST request

    // Making the POST request using Axios
    if (saleNo !== "" && season !== "") {
      openLoader();

      axiosMain
        .post(apiUrlAuctioneer, {
          season: season === "" ? new Date().getFullYear()?.toString() : season,
          saleNo: parseInt(saleNo),
          AuctioneerId: userId, //auctioner
          auctionCenterId: auctionCenterId,
        })
        .then((response) => {
          // Handle the API response here'

          setAuctioneer(response?.data?.responseData);
          closeLoader();

          console.log(response);
        })
        .catch((error) => {
          closeLoader();

          // Handle errors here
        });
      openLoader();
      axiosMain
        .post("/preauction/Common/GetSaleProgramDetailBySaleNo", {
          season: season === "" ? new Date().getFullYear()?.toString() : season,
          saleNo: parseInt(saleNo),
          auctionCenterId: auctionCenterId,
        })
        .then((res) => {
          setSaleProgramId(res.data.responseData);
          setAuctionType(res.data.responseData?.at(0)?.auctionTypeCode);
          setBaseUrlEng(
            res.data.responseData?.at(0)?.auctionTypeCode === "ENGLISH"
              ? "EnglishAuctionSession"
              : "AuctionSession"
          );
          let url =
            res.data.responseData?.at(0)?.auctionTypeCode === "ENGLISH"
              ? "EnglishAuctionSession"
              : "AuctionSession";

          if (
            res.data.responseData?.at(0)?.auctionTypeCode !== "ENGLISH" &&
            auctioneer?.length > 0
          ) {
            const saleNo = formik.values.saleNo;
            const season = formik.values.season;

            const marketTypeIdapiUrlCatagory =
              "/preauction/Common/BindMarketTypeByParam";

            axiosMain
              .post(marketTypeIdapiUrlCatagory, {
                season:
                  season === "" ? new Date().getFullYear()?.toString() : season,
                saleNo: parseInt(saleNo),
                AuctioneerId: parseInt(auctioneer?.at(0)?.userId),
                auctionCenterId: auctionCenterId,
              })
              .then((response) => {
                if (markType.length <= 0) {
                  setMarkType(
                    response?.data?.responseData?.map((ele) => ({
                      ...ele,
                      auctioneerId: parseInt(auctioneer?.at(0)?.userId),
                    }))
                  );
                } else {
                  if (
                    !markType
                      .map((ele) => ele.auctioneerId)
                      .includes(parseInt(auctioneer?.at(0)?.userId))
                  ) {
                    setMarkType([
                      ...markType,
                      ...response?.data?.responseData?.map((ele) => ({
                        ...ele,
                        auctioneerId: parseInt(auctioneer?.at(0)?.userId),
                      })),
                    ]);
                  }
                }
                closeLoader();
              })
              .catch((error) => {
                closeLoader();

                // Handle errors here
              });
          }
          openLoader();
          axiosMain
            .post(`/preauction/${url}/GetSaleDateAndTeaType`, {
              saleNo: parseInt(saleNo),
              season:
                season === "" ? new Date().getFullYear()?.toString() : season,
              auctionCenterId: auctionCenterId,
            })
            .then((response) => {
              dispatch(
                fetchSessionTypeRequest(
                  res.data.responseData?.at(0)?.auctionTypeCode
                )
              );
              if (
                dataBy?.dataByID?.responseData?.at(0) === undefined
                // dataBy.onEdit !== false
              ) {
                // Handle the API response here
                formik.setFieldValue(
                  "saleDate",
                  response?.data?.responseData[0]?.saleDate?.split("T")[0]
                );
              }

              setSaleDates(response?.data?.responseData);
              if (
                dataBy?.dataByID?.responseData?.at(0)?.saleDate === undefined
              ) {
                itemsOnPage
                  .slice(startIndex, endIndex)
                  ?.map(
                    (ele, index) =>
                      (selectedSalePrograms[index].saleDate =
                        response?.data?.responseData[0]?.saleDate?.split(
                          "T"
                        )[0])
                  );
              }

              closeLoader();
              console.log(selectedSalePrograms);
            })
            .catch((error) => {
              closeLoader();

              // Handle errors here
            });
          if (dataBy?.dataByID?.responseData?.length > 0) {
            // formik.setFieldValue(
            //   "dealBookClosingDate",
            //   dataBy?.dataByID?.responseData?.at(0)?.dealBookClosingDate
            // );
          } else {
            axiosMain
              .post(`/preauction/${url}/ConfigureDealBookTime`, {
                season:
                  season === "" ? new Date().getFullYear()?.toString() : season,
                saleNo: parseInt(saleNo),
                auctionCenterId: auctionCenterId,
              })
              .then((res) => {
                console.log(res.data.responseData, "resData");
                if (res.data.statusCode === 200) {
                  // formik.setFieldValue(
                  //   "dealBookClosingDate",
                  //   res.data.responseData?.at(0)?.dealBookClosingDate
                  // );
                } else {
                  // formik.setFieldValue("dealBookClosingDate", "");
                }
              })
              .catch((err) => {
                closeLoader();

                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // Cleanup function, in case you need to cancel the request
      return () => {
        // Cancel the request (if necessary) to avoid memory leaks
      };
    }
  }, [formik.values.saleNo, formik.values.season]);

  useEffect(() => {
    setNumRows(
      dataBy?.dataByID?.responseData?.at(0) !== undefined || onEdit
        ? 1
        : formik.values.noOfSession
    );
    setPageSize(
      dataBy?.dataByID?.responseData?.at(0) !== undefined || onEdit
        ? 1
        : formik.values.noOfSession
    );
  }, [formik.values.noOfSession]);

  function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = currentYear; i > currentYear - 7; i--) {
      options.push({ label: i, value: i });
    }

    return options;
  }

  const fields = [
    {
      label: "Season",
      name: "season",
      type:
        dataBy?.dataByID?.responseData?.at(0) !== undefined
          ? "disableSelect"
          : "select",
      options: generateYearOptions(),
      required: false,
      className: "FormGroup",
    },
    {
      label: "Sale No",
      name: "saleNo",
      type:
        dataBy?.dataByID?.responseData?.at(0) !== undefined
          ? "disableSelect"
          : "select",
      options: saleNo?.map((ele) => {
        return { label: ele.saleNo, value: ele.saleNo };
      }),
      required: false,
      className: "FormGroup",
    },

    {
      label: "Sale Date",
      name: "saleDate",
      type:
        dataBy?.dataByID?.responseData?.at(0) !== undefined
          ? "disableSelect"
          : "select",
      options: saleDates?.map((ele) => {
        return {
          label: newformatDateToDdMmYy(ele.saleDate?.split("T")?.at(0)),
          value: ele.saleDate?.split("T")?.at(0),
        };
      }),
      required: true,
      className: "FormGroup",
    },
    {
      label: "Tea Type",
      name: "teaTypeId",
      type: "disableSelect",
      options: teaTypeList?.map((ele) => {
        return { label: ele.teaTypeName, value: ele.teatypeid };
      }),
      required: false,
      className: "FormGroup",
    },
    {
      label: "No of Session",
      name: "noOfSession",
      type:
        dataBy?.dataByID?.responseData?.at(0) !== undefined
          ? "disable"
          : "text",
      required: false,
      className: "FormGroup",
    },
    // {
    //   label: "Deal Book Closing Date & Time",
    //   name: "dealBookClosingDate",
    //   type:
    //     dataBy?.dataByID?.responseData?.at(0) !== undefined
    //       ? dataBy?.dataByID?.responseData?.some((ele) => ele.status === 4) &&
    //         dataBy.onEdit === false
    //         ? "dateTimePicker"
    //         : "disableDateTimePicker"
    //       : "disableDateTimePicker",
    //   required: false,
    //   className: "FormGroup",
    // },
  ];

  const Controlls = () => {
    return <></>;
  };

  //Manage status
  function GetStatus(status) {
    if (baseUrlEng === "EnglishAuctionSession") {
      switch (status) {
        case 0: {
          return "Pending";
        }
        case 1: {
          return "Active";
        }
        case 2: {
          return "Inactive";
        }
        case 3: {
          return "Warm up";
        }
        case 4: {
          return "Closed";
        }
        case 5: {
          return "Cancelled";
        }
        case 6: {
          return "Hold";
        }
        case 7: {
          return "Resume";
        }
        case 8: {
          return "PrePond";
        }
        case 9: {
          return "PostPond";
        }
        case 10: {
          return "Inactive";
        }
        case 12: {
          return "Pending (Lot(s) are not mapped)";
        }
        default:
          return "-";
      }
    } else {
      switch (status) {
        case 0: {
          return "Pending";
        }
        case 1: {
          return "Active";
        }
        case 2: {
          return "Inactive";
        }
        case 3: {
          return "Warm up";
        }
        case 4: {
          return "Closed";
        }
        case 5: {
          return "Cancelled";
        }
        case 6: {
          return "Hold";
        }
        case 7: {
          return "Resume";
        }
        case 8: {
          return "PrePond";
        }
        case 9: {
          return "PostPond";
        }
        case 12: {
          return "Pending (Lot(s) are not mapped)";
        }
        default:
          return "-";
      }
    }
  }
  const updateSelectedSaleProgram = (index, updatedProgram) => {
    try {
      const updatedPrograms = [...selectedSalePrograms];
      updatedPrograms[index] = updatedProgram;

      // You can perform the API call regardless of whether saleDate is available or not

      setSelectedSalePrograms(updatedPrograms);
    } catch (error) {
      console.error("API call error:", error);
      // Handle the error if needed
    }
  };
  useEffect(() => {
    const saleNo = formik.values.saleNo;
    const season = formik.values.season;
    const saleDate = formik.values.saleDate;
    // API endpoint URL
    const apiUrl = `/preauction/${baseUrlEng}/GetTeaTypeByParam`;

    // Data to be sent in the POST request

    // Making the POST request using Axios
    if (saleNo !== 0 && saleDate !== "") {
      openLoader();
      axiosMain
        .post(apiUrl, {
          season: season === "" ? new Date().getFullYear()?.toString() : season,
          saleNo: parseInt(saleNo),
          saleDate: saleDate,
          auctionCenterId: auctionCenterId,
        })
        .then((response) => {
          // Handle the API response here
          formik.setFieldValue(
            "teaTypeId",
            response?.data?.responseData?.at(0)?.teatypeid
          );
          setTeaTeatypeList(response?.data?.responseData);
          formik.values.teaTypeId =
            response?.data?.responseData?.at(0)?.teatypeid;

          //Getteatypebyname
          axiosMain
            .post("/preauction/AuctionSession/GetTeaTypeByName", {
              season:
                season === "" ? new Date().getFullYear()?.toString() : season,
              saleNo: parseInt(saleNo),
              saleDate: saleDate,
              auctionCenterId: auctionCenterId,
              teaTypeName: response?.data?.responseData?.at(0)?.teaTypeName,
              teaTypeId: formik.values.teaTypeId,
            })
            .then((res) => {
              if (
                dataBy?.dataByID?.responseData !== undefined &&
                dataBy?.dataByID?.responseData?.length > 0
              ) {
                axiosMain
                  .post("/admin/Category/dropdown/getcategory", {
                    teaTypeId: dataBy?.dataByID?.responseData?.at(0)?.teaTypeId,
                    auctionCenterId: auctionCenterId,
                    isCategory: 1,
                  })
                  .then((response) => {
                    if (catagory?.length <= 0) {
                      setCategory(
                        response?.data?.responseData?.map((ele) => ({
                          ...ele,
                          teaTypeId: parseInt(
                            dataBy?.dataByID?.responseData?.at(0)?.teaTypeId
                          ),
                        }))
                      );
                      // debugger;
                    } else {
                      if (
                        !catagory
                          ?.map((ele) => ele.teaTypeId)
                          ?.includes(
                            parseInt(
                              dataBy?.dataByID?.responseData?.at(0)?.teaTypeId
                            )
                          )
                      ) {
                        setCategory([
                          ...catagory,
                          ...response?.data?.responseData?.map((ele) => ({
                            ...ele,
                            teaTypeId: parseInt(
                              dataBy?.dataByID?.responseData?.at(0)?.teaTypeId
                            ),
                          })),
                        ]);
                        // debugger;
                      }
                    }
                    closeLoader();
                  });
              } else {
                //Get Category Of tea type
                axiosMain
                  .post("/admin/Category/dropdown/getcategory", {
                    teaTypeId: parseInt(
                      res?.data?.responseData?.at(0)?.TeaTypeId
                    ),
                    auctionCenterId: auctionCenterId,
                    isCategory: 1,
                  })
                  .then((responseCategory) => {
                    if (responseCategory?.data?.statusCode === 200) {
                      if (catagory?.length <= 0) {
                        setCategory(
                          responseCategory?.data?.responseData.map((ele) => ({
                            ...ele,
                            teaTypeId: parseInt(
                              res?.data?.responseData?.at(0)?.TeaTypeId
                            ),
                          }))
                        );
                        // debugger;
                      } else {
                        if (
                          !catagory
                            ?.map((ele) => ele.teaTypeId)
                            ?.includes(
                              parseInt(
                                res?.data?.responseData?.at(0)?.TeaTypeId
                              )
                            )
                        ) {
                          setCategory([
                            ...catagory,
                            ...responseCategory?.data?.responseData.map(
                              (ele) => ({
                                ...ele,
                                teaTypeId: parseInt(
                                  res?.data?.responseData?.at(0)?.TeaTypeId
                                ),
                              })
                            ),
                          ]);
                          // debugger;
                        }
                      }
                    }
                    closeLoader();
                  });
                // selectedSalePrograms?.map(
                //   (ele) =>
                //     (ele.teaTypeId = res?.data?.responseData?.at(0)?.TeaTypeId)
                // );
              }

              setTeaTeatypeListdtls(res?.data?.responseData);
              console.log(res);
              // Handle the API response here
            })
            .catch((ex) => {
              closeLoader();

              console.log(ex);
              // Handle errors here
            });
        })
        .catch((error) => {
          closeLoader();

          // Handle errors here
        });

      // Cleanup function, in case you need to cancel the request
      return () => {
        // Cancel the request (if necessary) to avoid memory leaks
      };
    }
  }, [formik.values.saleDate, numRows]);

  const validateTimeRanges = () => {
    selectedSalePrograms.map((ele, index) => {
      if (
        selectedSalePrograms[index - 1]?.endTime >
        selectedSalePrograms[index].startTime
      ) {
        console.log(
          "The end time of the first interval is greater than the start time of the second interval."
        );
      } else {
        console.log(
          "The end time of the first interval is not greater than the start time of the second interval."
        );
      }
    });
  };

  // console.log(, "validateTimeRanges");

  const handlePrePost = (rowData) => {
    // if (
    //   dataBy?.dataByID?.responseData?.at(0)?.auctionSessionList !== undefined
    // ) {
    //   setPrePostData(
    //     dataBy?.dataByID?.responseData?.at(0)?.auctionSessionList?.at(rowData)
    //   );
    // } else {
    //   setPrePostData({});
    // }
    setAuctionSessionDetailId(
      selectedSalePrograms[rowData]?.auctionSessionDetailId
    );
    //debugger;
    axiosMain
      .get(
        `/preauction/${baseUrlEng}/PrePostponeAuctionSessionRequest?auctionSessionDetailId=` +
          selectedSalePrograms[rowData]?.auctionSessionDetailId
      )
      .then((response) => {
        setPrePostData(response.data.responseData?.at(0));
      });

    setSmShow(true);
  };

  function calculateEndTime(startTime) {
    // //debugger;
    // Split the input time into hours and minutes
    let [startHour, startMinute] = startTime.split(":").map(Number);

    // Create a new Date object with today's date and the provided time
    let startDate = new Date();
    startDate.setHours(startHour, startMinute, 0, 0);

    // Add 10 minutes to the start time
    let endDate = new Date(startDate.getTime() + 10 * 60000); // 10 minutes in milliseconds

    // Format the end time as a string (HH:MM format)
    let formattedEndTime =
      ("0" + endDate.getHours()).slice(-2) +
      ":" +
      ("0" + endDate.getMinutes()).slice(-2);

    return formattedEndTime;
  }

  function generateTimeSlots(startTime, numberOfRows, index) {
    const timeSlots = [];
    const timeGap = 10; // 10 minutes gap

    // Convert start time to Date object
    const startDate = new Date(`01/01/2000 ${startTime}`);

    let previousEndTime = null;

    for (let i = 0; i < numberOfRows; i++) {
      let newStartTime;

      if (index === 0) {
        newStartTime = new Date(startDate.getTime() - timeGap * 60000);
      } else {
        newStartTime = previousEndTime
          ? new Date(previousEndTime.getTime() + 60000)
          : new Date(startDate.getTime());
      }

      const newEndTime = new Date(newStartTime.getTime() + timeGap * 60000);

      const formattedStartTime = newStartTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      const formattedEndTime = newEndTime.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });

      timeSlots.push({
        startTime: formattedStartTime,
        endTime: formattedEndTime,
      });

      previousEndTime = newEndTime;
    }

    return timeSlots;
  }

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("dragIndex", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, dropIndex) => {
    const dragIndex = e.dataTransfer.getData("dragIndex");
    const updatedColumns = [...columns];
    const draggedColumn = updatedColumns.splice(dragIndex, 1)[0];
    updatedColumns.splice(dropIndex, 0, draggedColumn);
    setColumns(updatedColumns);
  };

  const convertToCustomFormat = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed, so add 1
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Return in DD/MM/YYYY HH:mm format
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const convertDateTime = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    // Return the datetime-local format: yyyy-MM-ddTHH:mm
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <>
      <div>
        <ConfirmationModal
          show={openDelete}
          title={"Are you sure you "}
          onDelete={() => {
            setRows([...rows?.filter((ele) => ele.id !== actionData.edit.id)]);
            setOpenDelete(false);
          }}
          onHide={() => setOpenDelete(false)}
        />
        {/* updatetime popup */}
        <ConfirmationModal
          show={openConformationModal}
          title={updatemessage}
          onYes={async () => {
            setbool(true);
            await formik.handleSubmit();
            setOpenConformationModal(false);
            setupdatemessage("");
          }}
          onHide={() => setOpenConformationModal(false)}
        />

        <form onSubmit={formik.handleSubmit}>
          <div>
            <div>
              {/* by sdp */}
              <div className="row">
                <CustomeFormCreater
                  fields={fields}
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  formik={formik}
                  Controlls={Controlls}
                  setHandleChnage={setHandleChnage}
                />
              </div>

              <div className=" TableBox normal-table">
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="resizable-columns-table"
                >
                  <thead>
                    {/* <tr>
                      <th style={{ minWidth: "200px" }}>Auctioneer</th>
                      {auctionType !== "ENGLISH" && (
                        <th style={{ minWidth: "200px" }}>Market Type</th>
                      )}
                      <th style={{ minWidth: "200px" }}>TeaType</th>
                      <th style={{ minWidth: "200px" }}>Category</th>
                      <th style={{ minWidth: "200px" }}>Session Type</th>
                      <th>Sale Date</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Minimum Bid Time</th>
                      <th>No Of Lots</th>
                      <th style={{ minWidth: "100px" }}>Status</th>
                    </tr> */}

                    <tr>
                      {columns.map((column, index) => (
                        <th
                          key={index}
                          draggable
                          onDragStart={(e) => handleDragStart(e, index)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, index)}
                          style={{ width: column.minWidth }}
                        >
                          <div className="resizable-columns">
                            {" "}
                            {column.label}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {itemsOnPage
                      .slice(startIndex, endIndex)
                      ?.map((item, index) => (
                        <tr key={index}>
                          {columns.map((ele) => (
                            <>
                              {ele.id === "userId" && (
                                <td>
                                  <FormControl
                                    as="select"
                                    size="sm"
                                    name="userId"
                                    value={
                                      selectedSalePrograms[index]?.userId || ""
                                    }
                                    onChange={(e) => {
                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          userId: parseInt(e.target.value),
                                        };

                                        const saleNo = formik.values.saleNo;
                                        const season = formik.values.season;

                                        const marketTypeIdapiUrlCatagory =
                                          "/preauction/Common/BindMarketTypeByParam";

                                        axiosMain
                                          .post(marketTypeIdapiUrlCatagory, {
                                            season:
                                              season === ""
                                                ? new Date()
                                                    .getFullYear()
                                                    ?.toString()
                                                : season,
                                            saleNo: parseInt(saleNo),
                                            AuctioneerId: parseInt(
                                              e.target.value
                                            ),
                                            auctionCenterId: auctionCenterId,
                                          })
                                          .then((response) => {
                                            // Handle the API response here
                                            selectedSalePrograms[
                                              index
                                            ].marketTypeId =
                                              response?.data?.responseData?.at(
                                                0
                                              )?.marketTypeId;
                                            selectedSalePrograms[
                                              index
                                            ].marketTypeName =
                                              response?.data?.responseData[0].marketTypeName;

                                            if (markType.length <= 0) {
                                              setMarkType(
                                                response?.data?.responseData?.map(
                                                  (ele) => ({
                                                    ...ele,
                                                    auctioneerId: parseInt(
                                                      e.target.value
                                                    ),
                                                  })
                                                )
                                              );
                                            } else {
                                              if (
                                                !markType
                                                  .map(
                                                    (ele) => ele.auctioneerId
                                                  )
                                                  .includes(
                                                    parseInt(e.target.value)
                                                  )
                                              ) {
                                                setMarkType([
                                                  ...markType,
                                                  ...response?.data?.responseData?.map(
                                                    (ele) => ({
                                                      ...ele,
                                                      auctioneerId: parseInt(
                                                        e.target.value
                                                      ),
                                                    })
                                                  ),
                                                ]);
                                              }
                                            }
                                          })
                                          .catch((error) => {
                                            // Handle errors here
                                          });
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      } else {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          userId: parseInt(e.target.value),
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );

                                        if (auctionType !== "ENGLISH") {
                                          const saleNo = formik.values.saleNo;
                                          const season = formik.values.season;

                                          const marketTypeIdapiUrlCatagory =
                                            "/preauction/Common/BindMarketTypeByParam";

                                          axiosMain
                                            .post(marketTypeIdapiUrlCatagory, {
                                              season:
                                                season === ""
                                                  ? new Date()
                                                      .getFullYear()
                                                      ?.toString()
                                                  : season,
                                              saleNo: parseInt(saleNo),
                                              AuctioneerId: parseInt(
                                                e.target.value
                                              ),
                                              auctionCenterId: auctionCenterId,
                                            })
                                            .then((response) => {
                                              // debugger;

                                              if (markType.length <= 0) {
                                                setMarkType(
                                                  response?.data?.responseData?.map(
                                                    (ele) => ({
                                                      ...ele,
                                                      auctioneerId: parseInt(
                                                        e.target.value
                                                      ),
                                                    })
                                                  )
                                                );
                                              } else {
                                                if (
                                                  !markType
                                                    .map(
                                                      (ele) => ele.auctioneerId
                                                    )
                                                    .includes(
                                                      parseInt(e.target.value)
                                                    )
                                                ) {
                                                  setMarkType([
                                                    ...markType,
                                                    ...response?.data?.responseData?.map(
                                                      (ele) => ({
                                                        ...ele,
                                                        auctioneerId: parseInt(
                                                          e.target.value
                                                        ),
                                                      })
                                                    ),
                                                  ]);
                                                }
                                              }
                                            })
                                            .catch((error) => {
                                              // Handle errors here
                                            });
                                        }
                                      }
                                    }}
                                    disabled={
                                      dataBy?.dataByID?.responseData?.at(0) !==
                                      undefined
                                        ? auctionType === "ENGLISH" &&
                                          onEdit === false
                                          ? false
                                          : selectedSalePrograms[index]
                                              ?.sessionTypeName !== "Normal" ||
                                            selectedSalePrograms[index]
                                              ?.status === 1 ||
                                            selectedSalePrograms[index]
                                              ?.status === 4 ||
                                            selectedSalePrograms[index]
                                              ?.status === 5
                                          ? true
                                          : onEdit
                                        : false
                                    }
                                  >
                                    <option value={0}>Select Auctioneer</option>

                                    {auctioneer?.length > 0 ? (
                                      auctioneer?.map((item, index) => (
                                        <option
                                          value={item.userId}
                                          key={item.userId}
                                        >
                                          {item.userCode}
                                        </option>
                                      ))
                                    ) : (
                                      <option>No Data</option>
                                    )}
                                  </FormControl>
                                </td>
                              )}

                              {ele.id === "marketTypeId" &&
                                auctionType !== "ENGLISH" && (
                                  <td>
                                    <FormControl
                                      as="select"
                                      size="sm"
                                      name="marketTypeId"
                                      value={
                                        selectedSalePrograms[index]
                                          ?.marketTypeId || ""
                                      }
                                      onChange={(e) => {
                                        if (
                                          dataBy?.dataByID?.responseData?.at(
                                            0
                                          ) !== undefined
                                        ) {
                                          const updatedProgram = {
                                            ...selectedSalePrograms[index],
                                            marketTypeId: parseInt(
                                              e.target.value
                                            ),
                                          };
                                          updateSelectedSaleProgram(
                                            index,
                                            updatedProgram
                                          );
                                        } else {
                                          const updatedProgram = {
                                            ...selectedSalePrograms[index],
                                            marketTypeId: parseInt(
                                              e.target.value
                                            ),
                                          };
                                          updateSelectedSaleProgram(
                                            index,
                                            updatedProgram
                                          );
                                        }
                                      }}
                                      disabled={
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                          ? auctionType === "ENGLISH" &&
                                            onEdit === false
                                            ? false
                                            : selectedSalePrograms[index]
                                                ?.sessionTypeName !==
                                                "Normal" ||
                                              selectedSalePrograms[index]
                                                ?.status === 1 ||
                                              selectedSalePrograms[index]
                                                ?.status === 4 ||
                                              selectedSalePrograms[index]
                                                ?.status === 5
                                            ? true
                                            : onEdit
                                          : false
                                      }
                                      className="w-100"

                                      // disabled
                                    >
                                      <option value="">
                                        Select Market Type
                                      </option>
                                      {markType?.length > 0 ? (
                                        markType
                                          ?.filter(
                                            (item) =>
                                              item.auctioneerId ===
                                              parseInt(
                                                selectedSalePrograms[index]
                                                  ?.userId
                                              )
                                          )
                                          ?.map((item, index) => (
                                            <option
                                              value={item.marketTypeId}
                                              key={item.marketTypeId}
                                            >
                                              {item.marketTypeName}
                                            </option>
                                          ))
                                      ) : (
                                        <option>No Data</option>
                                      )}
                                    </FormControl>
                                  </td>
                                )}
                              {ele.id === "teaTypeId" && (
                                <td>
                                  <FormControl
                                    as="select"
                                    size="sm"
                                    name="teaTypeId"
                                    className="w-100"
                                    value={
                                      selectedSalePrograms[index]?.teaTypeId
                                    }
                                    onChange={(e) => {
                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          teaTypeId: parseInt(e.target.value),
                                          categoryId: 0,
                                        };
                                        if (
                                          parseInt(e.target.value) !== null &&
                                          parseInt(e.target.value) !== 0
                                        ) {
                                          axiosMain
                                            .post(
                                              "/admin/Category/dropdown/getcategory",
                                              {
                                                teaTypeId: parseInt(
                                                  e.target.value
                                                ),
                                                auctionCenterId:
                                                  auctionCenterId,
                                                isCategory: 1,
                                              }
                                            )
                                            .then((response) => {
                                              if (catagory?.length <= 0) {
                                                setCategory(
                                                  response?.data?.responseData?.map(
                                                    (ele) => ({
                                                      ...ele,
                                                      teaTypeId: parseInt(
                                                        e.target.value
                                                      ),
                                                    })
                                                  )
                                                );
                                                // debugger;
                                              } else {
                                                if (
                                                  !catagory
                                                    ?.map(
                                                      (ele) => ele.teaTypeId
                                                    )
                                                    ?.includes(
                                                      parseInt(e.target.value)
                                                    )
                                                ) {
                                                  setCategory([
                                                    ...catagory,
                                                    ...response?.data?.responseData?.map(
                                                      (ele) => ({
                                                        ...ele,
                                                        teaTypeId: parseInt(
                                                          e.target.value
                                                        ),
                                                      })
                                                    ),
                                                  ]);
                                                  // debugger;
                                                }
                                              }
                                            });
                                        }
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      } else {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          teaTypeId: parseInt(e.target.value),
                                        };

                                        if (
                                          parseInt(e.target.value) !== null &&
                                          parseInt(e.target.value) !== 0
                                        ) {
                                          axiosMain
                                            .post(
                                              "/admin/Category/dropdown/getcategory",
                                              {
                                                teaTypeId: parseInt(
                                                  e.target.value
                                                ),
                                                auctionCenterId:
                                                  auctionCenterId,
                                                isCategory: 1,
                                              }
                                            )
                                            .then((response) => {
                                              if (catagory?.length <= 0) {
                                                setCategory(
                                                  response?.data
                                                    ?.responseData === null
                                                    ? []
                                                    : response?.data?.responseData?.map(
                                                        (ele) =>
                                                          ({
                                                            ...ele,
                                                            teaTypeId: parseInt(
                                                              e.target.value
                                                            ),
                                                          } || [])
                                                      )
                                                );
                                                // debugger;
                                              }
                                              //changes
                                              else {
                                                if (
                                                  !catagory
                                                    ?.map(
                                                      (ele) => ele.teaTypeId
                                                    )
                                                    ?.includes(
                                                      parseInt(e.target.value)
                                                    ) &&
                                                  response?.data?.responseData
                                                    ?.length > 0
                                                ) {
                                                  setCategory([
                                                    ...catagory,
                                                    ...response?.data?.responseData?.map(
                                                      (ele) => ({
                                                        ...ele,
                                                        teaTypeId: parseInt(
                                                          e.target.value
                                                        ),
                                                      })
                                                    ),
                                                  ]);
                                                  // debugger;
                                                }
                                              }
                                            });
                                        }

                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      }
                                    }}
                                    disabled={
                                      dataBy?.dataByID?.responseData?.at(0) !==
                                      undefined
                                        ? auctionType === "ENGLISH" &&
                                          onEdit === false
                                          ? false
                                          : selectedSalePrograms[index]
                                              ?.sessionTypeName !== "Normal" ||
                                            selectedSalePrograms[index]
                                              ?.status === 1 ||
                                            selectedSalePrograms[index]
                                              ?.status === 4 ||
                                            selectedSalePrograms[index]
                                              ?.status === 5
                                          ? true
                                          : onEdit
                                        : false
                                    }
                                  >
                                    <option value={0}>Select Tea Type</option>
                                    {teaTypeListdtls?.length > 0
                                      ? teaTypeListdtls?.map((item, index) => (
                                          <option value={item?.TeaTypeId}>
                                            {item.TeaTypeName}
                                          </option>
                                        ))
                                      : "No Data"}
                                  </FormControl>
                                </td>
                              )}
                              {ele.id === "categoryId" && (
                                <td>
                                  <FormControl
                                    as="select"
                                    size="sm"
                                    name="categoryId"
                                    className="w-100"
                                    value={
                                      selectedSalePrograms[index]?.categoryId ||
                                      ""
                                    }
                                    onChange={(e) => {
                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          categoryId: parseInt(e.target.value),
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      } else {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          categoryId: parseInt(e.target.value),
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      }
                                    }}
                                    disabled={
                                      dataBy?.dataByID?.responseData?.at(0) !==
                                      undefined
                                        ? auctionType === "ENGLISH" &&
                                          onEdit === false
                                          ? false
                                          : selectedSalePrograms[index]
                                              ?.sessionTypeName !== "Normal" ||
                                            selectedSalePrograms[index]
                                              ?.status === 1 ||
                                            selectedSalePrograms[index]
                                              ?.status === 4 ||
                                            selectedSalePrograms[index]
                                              ?.status === 5
                                          ? true
                                          : onEdit
                                        : false
                                    }
                                  >
                                    <option value={0}>Select Category</option>
                                    {catagory?.length > 0
                                      ? catagory
                                          ?.filter(
                                            (item) =>
                                              item.teaTypeId ===
                                              parseInt(
                                                selectedSalePrograms[index]
                                                  ?.teaTypeId
                                              )
                                          )
                                          ?.map((item, index) => (
                                            <option
                                              value={item.categoryId}
                                              key={index}
                                            >
                                              {item.categoryCode}
                                            </option>
                                          ))
                                      : "No Data"}
                                  </FormControl>
                                </td>
                              )}
                              {ele.id === "sessionTypeId" && (
                                <td>
                                  <FormControl
                                    as="select"
                                    size="sm"
                                    className="w-100"
                                    value={
                                      selectedSalePrograms[index]?.sessionTypeId
                                    }
                                    onChange={(e) => {
                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        let sessionTypeName = sessionTypes
                                          ?.filter(
                                            (ele) =>
                                              ele.sessionTypeId ===
                                              parseInt(e.target.value)
                                          )
                                          .at(0)?.sessionTypeName;
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          sessionTypeId: parseInt(
                                            e.target.value
                                          ),
                                          sessionTypeName: sessionTypeName,
                                        };

                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      } else {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          sessionTypeId: parseInt(
                                            e.target.value
                                          ),
                                          sessionTypeName: item.sessionTypeName,
                                        };

                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      }
                                    }}
                                    disabled={
                                      dataBy?.dataByID?.responseData?.at(0) !==
                                      undefined
                                        ? auctionType === "ENGLISH" &&
                                          onEdit === false
                                          ? false
                                          : selectedSalePrograms[index]
                                              ?.sessionTypeName !== "Normal" ||
                                            selectedSalePrograms[index]
                                              ?.status === 1 ||
                                            selectedSalePrograms[index]
                                              ?.status === 4 ||
                                            selectedSalePrograms[index]
                                              ?.status === 5
                                          ? true
                                          : true
                                        : auctionType !== "ENGLISH"
                                    }
                                  >
                                    {sessionTypes?.length > 0
                                      ? sessionTypes?.map((item, index) => (
                                          <option value={item?.sessionTypeId}>
                                            {item.sessionTypeName}
                                          </option>
                                        ))
                                      : "No Data"}
                                  </FormControl>
                                </td>
                              )}
                              {ele.id === "saleDate" && (
                                <td>
                                  <input
                                    type="date"
                                    id="saleDate"
                                    value={formik?.values?.saleDate}
                                    disabled
                                    className="w-100"
                                  />
                                </td>
                              )}
                              {ele.id === "startDate" && (
                                <td
                                  className="form-group"
                                  style={{ minWidth: "100px" }}
                                >
                                  <DatePicker
                                    selected={
                                      selectedSalePrograms[index]?.startDate
                                        ? new Date(
                                            `${selectedSalePrograms[index]?.startDate}`
                                          )
                                        : null
                                    }
                                    onChange={(date) => {
                                      // Format the selected time from DatePicker
                                      const selectedTime =
                                        date.toLocaleTimeString("en-US", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: false,
                                        });

                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        // Update the startDate for the selected program
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          startDate: `${formik?.values?.saleDate}T${selectedTime}:00`,
                                        };

                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      } else {
                                        console.log(
                                          calculateEndTime(selectedTime),
                                          generateTimeSlots(
                                            selectedTime,
                                            numRows,
                                            index
                                          ),
                                          "Time updated"
                                        );

                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          startDate: `${formik?.values?.saleDate}T${selectedTime}:00`,
                                        };

                                        console.log(
                                          new Date(
                                            `${
                                              updatedProgram?.startDate.split(
                                                "T"
                                              )[1]
                                            }`
                                          )
                                        );
                                        // debugger;

                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );

                                        setStartDate(selectedTime); // Update local state if needed
                                      }
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    disabled={
                                      formik?.values?.saleDate?.length > 0
                                        ? dataBy?.dataByID?.responseData?.at(
                                            0
                                          ) !== undefined
                                          ? selectedSalePrograms[index]
                                              ?.status === 1 ||
                                            selectedSalePrograms[index]
                                              ?.status === 4 ||
                                            selectedSalePrograms[index]
                                              ?.status === 5
                                            ? true
                                            : onEdit
                                          : false
                                        : true
                                    }
                                    className="form-control"
                                    style={{ minWidth: "100px" }}
                                  />
                                </td>
                              )}
                              {ele.id === "enddate" && (
                                <td
                                  className="form-group w-100"
                                  // style={{ minWidth: "100px" }}
                                  // className="w-100"
                                >
                                  {/* <input
                              type="time"
                              className="form-control"
                              id="enddate"
                              value={
                                selectedSalePrograms[index]?.enddate?.split(
                                  "T"
                                )[1] || ""
                              }
                              onChange={(e) => {
                                const updatedProgram = {
                                  ...selectedSalePrograms[index],
                                  enddate:
                                    formik?.values?.saleDate +
                                    "T" +
                                    e.target.value +
                                    ":00",
                                };

                                console.log(updatedProgram);
                                debugger;
                                if (
                                  dataBy?.dataByID?.responseData?.at(0) !==
                                  undefined
                                ) {
                                  if (e.target.value > startDate) {
                                    const updatedProgram = {
                                      ...selectedSalePrograms[index],
                                      enddate:
                                        formik?.values?.saleDate +
                                        "T" +
                                        e.target.value +
                                        ":00",
                                    };

                                    updateSelectedSaleProgram(
                                      index,
                                      updatedProgram
                                    );
                                  } else {
                                    CustomToast.error(
                                      "End Date must be grater then start date"
                                    );
                                  }
                                } else {
                                  if (e.target.value > startDate) {
                                    const updatedProgram = {
                                      ...selectedSalePrograms[index],
                                      enddate:
                                        formik?.values?.saleDate +
                                        "T" +
                                        e.target.value +
                                        ":00",
                                    };

                                    if (index + 1 <= numRows) {
                                      if (
                                        e.target.value >
                                        selectedSalePrograms[index]?.startDate
                                          ?.split("T")
                                          ?.at(1)
                                      ) {
                                        // debugger;
                                        addStartDateInNextRow(
                                          index,
                                          e.target.value,
                                          updatedProgram
                                        );
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                        debugger;
                                      } else {
                                        CustomToast.error(
                                          "End Date must be grater then start date"
                                        );
                                      }
                                    }
                                  } else {
                                    CustomToast.error(
                                      "End Date must be grater then start date"
                                    );
                                  }
                                }
                              }}
                              disabled={
                                dataBy?.dataByID?.responseData?.at(0) !==
                                undefined
                                  ? selectedSalePrograms[index]?.status === 1 ||
                                    selectedSalePrograms[index]?.status === 4 ||
                                    selectedSalePrograms[index]?.status === 5
                                    ? true
                                    : onEdit
                                  : false
                              }
                            /> */}

                                  <DatePicker
                                    selected={
                                      selectedSalePrograms[index]?.enddate
                                        ? new Date(
                                            `${selectedSalePrograms[index]?.enddate}`
                                          )
                                        : null
                                    }
                                    onChange={(date) => {
                                      const selectedTime =
                                        date.toLocaleTimeString("en-US", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: false,
                                        });

                                      let updatedProgram = {
                                        ...selectedSalePrograms[index],
                                        enddate: `${formik?.values?.saleDate}T${selectedTime}:00`,
                                      };

                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        if (selectedTime > startDate) {
                                          const combinedDateTime = new Date(
                                            `${formik.values.saleDate}T${selectedTime}:00`
                                          );
                                          // Add 2 hours
                                          combinedDateTime.setHours(
                                            combinedDateTime.getHours() + 2
                                          );
                                          if (selectedSalePrograms[index]) {
                                            const year =
                                              combinedDateTime.getFullYear();
                                            const month = String(
                                              combinedDateTime.getMonth() + 1
                                            ).padStart(2, "0");
                                            const day = String(
                                              combinedDateTime.getDate()
                                            ).padStart(2, "0");
                                            const hours = String(
                                              combinedDateTime.getHours()
                                            ).padStart(2, "0");
                                            const minutes = String(
                                              combinedDateTime.getMinutes()
                                            ).padStart(2, "0");
                                            const seconds = "00"; // Static seconds part

                                            const finalDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
                                            const finalDateTimeShow = `${year}-${month}-${day}T${hours}:${minutes}`;
                                            updatedProgram = {
                                              ...selectedSalePrograms[index],
                                              enddate: `${formik?.values?.saleDate}T${selectedTime}:00`,
                                              dealBookClosingDateTimeRow:
                                                finalDateTime,
                                              dealBookClosingDateTimeShow:
                                                finalDateTimeShow,
                                            };
                                          }

                                          updateSelectedSaleProgram(
                                            index,
                                            updatedProgram
                                          );
                                        } else {
                                          CustomToast.error(
                                            "End Date must be greater than start date"
                                          );
                                        }
                                      } else {
                                        if (selectedTime > startDate) {
                                          // updateSelectedSaleProgram(
                                          //   index,
                                          //   updatedProgram
                                          // );
                                          if (index + 1 <= numRows) {
                                            if (
                                              selectedTime >
                                              selectedSalePrograms[
                                                index
                                              ]?.startDate?.split("T")?.[1]
                                            ) {
                                              addStartDateInNextRow(
                                                index,
                                                selectedTime,
                                                updatedProgram
                                              );

                                              // handleAddTime(selectedTime, index);
                                              const combinedDateTime = new Date(
                                                `${formik.values.saleDate}T${selectedTime}:00`
                                              );
                                              // Add 2 hours
                                              combinedDateTime.setHours(
                                                combinedDateTime.getHours() + 2
                                              );
                                              if (selectedSalePrograms[index]) {
                                                const year =
                                                  combinedDateTime.getFullYear();
                                                const month = String(
                                                  combinedDateTime.getMonth() +
                                                    1
                                                ).padStart(2, "0");
                                                const day = String(
                                                  combinedDateTime.getDate()
                                                ).padStart(2, "0");
                                                const hours = String(
                                                  combinedDateTime.getHours()
                                                ).padStart(2, "0");
                                                const minutes = String(
                                                  combinedDateTime.getMinutes()
                                                ).padStart(2, "0");
                                                const seconds = "00"; // Static seconds part

                                                const finalDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
                                                const finalDateTimeShow = `${year}-${month}-${day}T${hours}:${minutes}`;
                                                updatedProgram = {
                                                  ...selectedSalePrograms[
                                                    index
                                                  ],
                                                  enddate: `${formik?.values?.saleDate}T${selectedTime}:00`,
                                                  dealBookClosingDateTimeRow:
                                                    finalDateTime,
                                                  dealBookClosingDateTimeShow:
                                                    finalDateTimeShow,
                                                };
                                                // updateSelectedSaleProgram(index,selectedSalePrograms[index])
                                              }
                                              updateSelectedSaleProgram(
                                                index,
                                                updatedProgram
                                              );
                                            } else {
                                              CustomToast.error(
                                                "End Date must be greater than start date"
                                              );
                                            }
                                          }
                                        } else {
                                          CustomToast.error(
                                            "End Date must be greater than start date"
                                          );
                                        }
                                      }
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    disabled={
                                      formik?.values?.saleDate?.length > 0
                                        ? dataBy?.dataByID?.responseData?.at(
                                            0
                                          ) !== undefined
                                          ? selectedSalePrograms[index]
                                              ?.status === 1 ||
                                            selectedSalePrograms[index]
                                              ?.status === 4 ||
                                            selectedSalePrograms[index]
                                              ?.status === 5
                                            ? true
                                            : onEdit
                                          : false
                                        : true
                                    }
                                    className="form-control"
                                  />
                                </td>
                              )}
                              {ele.id === "minimumBidTime" && (
                                <td>
                                  <input
                                    type="text"
                                    id="minimumBidTime"
                                    className="w-100"
                                    value={
                                      selectedSalePrograms[index]
                                        ?.minimumBidTime
                                    }
                                    onChange={(e) => {
                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          minimumBidTime:
                                            e.target.value === ""
                                              ? e.target.value
                                              : parseInt(e.target.value),
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      } else {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          minimumBidTime:
                                            e.target.value === ""
                                              ? e.target.value
                                              : parseInt(e.target.value),
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );

                                        console.log(
                                          index,
                                          e.target.value,
                                          selectedSalePrograms
                                        );
                                      }
                                    }}
                                    disabled={
                                      dataBy?.dataByID?.responseData?.at(0) !==
                                      undefined
                                        ? selectedSalePrograms[index]
                                            ?.status === 1 ||
                                          selectedSalePrograms[index]
                                            ?.status === 4 ||
                                          selectedSalePrograms[index]
                                            ?.status === 5
                                          ? true
                                          : onEdit
                                        : false
                                    }
                                    maxlength="2"
                                  />
                                  {/* <LocalizationProvider dateAdapter={AdapterDateFns}> */}
                                  {/* <TimePicker
                                label="Basic example"
                                value={value}
                                onChange={(newValue) => {
                                  setValue(newValue);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} />
                                )}
                              /> */}
                                  {/* </LocalizationProvider> */}
                                </td>
                              )}
                              {ele.id === "noOfLots" && (
                                <td>
                                  <input
                                    type="text"
                                    id="No of Lots"
                                    value={
                                      selectedSalePrograms[index]?.noOfLots
                                    }
                                    maxLength={4}
                                    onChange={(e) => {
                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          noOfLots:
                                            e.target.value === ""
                                              ? e.target.value
                                              : parseInt(e.target.value),
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      } else {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          noOfLots:
                                            e.target.value === ""
                                              ? e.target.value
                                              : parseInt(e.target.value),
                                          status: 0,
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      }
                                    }}
                                    disabled={
                                      dataBy?.dataByID?.responseData?.at(0) !==
                                      undefined
                                        ? selectedSalePrograms[index]
                                            ?.status === 1 ||
                                          selectedSalePrograms[index]
                                            ?.status === 4 ||
                                          selectedSalePrograms[index]
                                            ?.status === 5
                                          ? true
                                          : onEdit
                                        : false
                                    }
                                    className="w-100"
                                  />
                                </td>
                              )}
                              {ele.id === "dealBookClosingDateTimeRow" && (
                                <td>
                                  <input
                                    type={
                                      dataBy?.dataByID?.responseData?.at(0) !==
                                      undefined
                                        ? dataBy?.dataByID?.responseData?.some(
                                            (ele) => ele.status === 4
                                          ) && dataBy.onEdit === false
                                          ? "datetime-local"
                                          : "datetime-local"
                                        : "datetime-local"
                                    }
                                    id="dealBookClosingDateTimeRow"
                                    value={selectedSalePrograms[
                                      index
                                    ]?.dealBookClosingDateTimeShow?.slice(
                                      0,
                                      16
                                    )}
                                    maxLength={4}
                                    min={new Date().toISOString().slice(0, 16)} // set minimum datetime
                                    onChange={(e) => {
                                      const selectedValue = e.target.value;
                                      const now = new Date();
                                      const selectedDate = new Date(
                                        selectedValue
                                      );

                                      if (selectedDate <= now) {
                                        CustomToast.warning(
                                          "Please select a future date and time."
                                        );
                                        return;
                                      }

                                      const updatedProgram = {
                                        ...selectedSalePrograms[index],
                                        dealBookClosingDateTimeRow:
                                          selectedValue,
                                        dealBookClosingDateTimeShow:
                                          selectedValue,
                                      };
                                      updateSelectedSaleProgram(
                                        index,
                                        updatedProgram
                                      );
                                    }}
                                    disabled={
                                      !(
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined &&
                                        dataBy?.dataByID?.responseData?.some(
                                          (ele) => ele.status === 4
                                        ) &&
                                        dataBy.onEdit === false
                                      )
                                    }
                                    className="w-100"
                                    // style={{ width: "140% !important" }}
                                  />
                                </td>
                              )}
                              {ele.id === "status" && (
                                <td>
                                  <input
                                    type="text"
                                    id="Status"
                                    value={GetStatus(
                                      selectedSalePrograms[index]?.status
                                    )}
                                    onChange={(e) => {
                                      if (
                                        dataBy?.dataByID?.responseData?.at(
                                          0
                                        ) !== undefined
                                      ) {
                                        selectedSalePrograms[index].status = 0;
                                      } else {
                                        const updatedProgram = {
                                          ...selectedSalePrograms[index],
                                          status: 0,
                                        };
                                        updateSelectedSaleProgram(
                                          index,
                                          updatedProgram
                                        );
                                      }
                                    }}
                                    className="w-100"
                                    disabled
                                  />
                                </td>
                              )}
                            </>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
              <div className="py-3">
                <ul
                  style={{
                    "font-weight": "bold",
                    marginLeft: "2rem !important",
                  }}
                >
                  <li>
                    <p className="Red">
                      ● Note: Deal Book Closing Date & Time is auto-calculated
                      as 2 hours after the scheduled end time of the session.
                    </p>
                  </li>
                  <li>
                    <p className="Red">
                      ● For example, if the session ends at 12:00, the Deal Book
                      Closing Time will be 14:00.
                    </p>
                  </li>
                  <li>
                    <p className="Red">
                      ● You may update this time if required after completion of
                      the auction session.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="py-3">
                <div className="BtnGroup">
                  {dataBy?.dataByID?.responseData?.at(0) !== undefined &&
                  onEdit == true ? (
                    ""
                  ) : (
                    <button type="submit" className="SubmitBtn">
                      {dataBy?.dataByID?.responseData?.at(0) !== undefined
                        ? "Update"
                        : "Submit"}
                    </button>
                  )}
                  {dataBy?.dataByID?.responseData?.at(0) !== undefined &&
                  onEdit == false ? (
                    <button
                      type="button"
                      onClick={() =>
                        dataBy?.dataByID?.responseData?.at(0) !== undefined
                          ? getEditValues()
                          : resetForm()
                      }
                      className="SubmitBtn"
                    >
                      <i className="fa fa-refresh"></i>
                    </button>
                  ) : (
                    <> </>
                  )}
                </div>
                {onEdit && (
                  <>
                    <div className="BtnGroup">
                      <ExportToPDF
                        dataNew={ExceldatafordownloadfirstRow}
                        data={Exceldatafordownload}
                        fileName="AuctionSession"
                        auctionType={auctionType}
                      />
                      <ExportData
                        columnsdataNew={columnsdata}
                        dataNew={ExceldatafordownloadfirstRow}
                        columnsdata={columnsdataNew}
                        data={Exceldatafordownload}
                        fileName="AuctionSession"
                        exportType={"downloadExcel"}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
      <Modal
        size="xl"
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            Prepone/Postpone Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to want to Prepone/Postpone the selected auction session?
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-md-6">
              <button onClick={() => setShow(true)}>Yes</button>
            </div>
            <div className="col-md-6">
              <button onClick={() => setSmShow(false)}>No</button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show}
        size="xl"
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            {`Postpone details of auctioneer ${prePostData?.userName} for Season ${formik.values.season} Sale No. ${formik.values.saleNo} and Tea Type: ${prePostData?.teaTypeName}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PrePostDate
            dateAndTime={prePostData}
            setShow={setShow}
            setSmShow={setSmShow}
            setExpandedTab={dataBy?.setExpandedTab}
            auctionSessionDetailId={auctionSessionDetailId}
            baseUrlEng={baseUrlEng}
            saleProgramIds={saleProgramIds}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Maintananse;
